import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs.extend(utc)

export const formatDateForChart = (dateString: string | number) => {
    const isNumberString = !isNaN(Number(dateString))
    const date = dayjs.utc(isNumberString ? Number(dateString) : dateString)
    return date.format("MMM 'YY") // e.g. "Aug '24"
}
